export default "__VITE_ASSET__daViq$Ym__"